module.exports = __webpack_public_path__ + "static/media/checkbox-empty.6f8d70d6.svg";